var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"report"}},[_c('div',{staticStyle:{"height":"90vh"},attrs:{"id":"container"}})])}]

export { render, staticRenderFns }